<script setup>
import {useFormField} from "../../../Registration/composables/useFormField";
import {useProcessedOptions} from "../../../Registration/composables/useProcessedOptions";
import FieldErrorMessage from "../../../Registration/components/Fields/FieldErrorMessage.vue";

const emit = defineEmits(['blur', 'input']);

const {item, group, groupId, backend} = defineProps(['item','group','groupId', 'backend']);
const {model, uniqueItemId, options, path, isReadOnly, getFieldClasses, getPrefix, createBlurHandler, createInputHandler} = useFormField(item, group, groupId, (v) => v, (v) => v, backend);
const {processedOptions} = useProcessedOptions(item, options, getPrefix, isReadOnly, model, group, groupId);

const handleBlur = createBlurHandler(emit);
const handleInput = createInputHandler(emit);

const layout = item.data.layout;
let wrapperClass ='flex-col';
let optionsWrapperClass = 'w-full flex-col justify-center';
if(layout === 'horizontal'){
    wrapperClass = 'flex-col md:flex-row flex-wrap items-start';
    optionsWrapperClass = 'mr-4 items-center';
}

const className = getFieldClasses('w-full form-group form-wrapper multiselect-checkbox-field checkbox-field');

const handleClick = (event) => {
    if (isReadOnly.value) {
        event.preventDefault();
        return false;
    }

    // Additional check for disabled options
    const optionKey = event.target.value;
    const option = processedOptions.value?.find(opt => opt.key === optionKey);
    if (option?.disabled) {
        event.preventDefault();
        return false;
    }
};
</script>

<template>
    <div :class="className">
        <div>
            <label v-if="item.label !== null" class="mr-2 field-label" :for="uniqueItemId">
                {{ item.label }}
                <span v-if="item.required && !isReadOnly"> *</span>
            </label>
        </div>

        <div :class="`mt-2 flex gap-x-4 gap-y-2 ${wrapperClass}`">
            <div v-for="option in processedOptions"
                 :key="`${uniqueItemId}-${option.key}-wrapper`"
                 :class="[
                     `mt-2 multiselect-checkbox-field-item flex ${optionsWrapperClass}`,
                     { 'opacity-50 pointer-events-none': option.disabled }
                 ]">
                <label :for="`${uniqueItemId}-${option.key}`"
                       class="flex w-max max-w-full"
                >
                    <input
                        type="checkbox"
                        class="form-check-box shrink-0"
                        :id="`${uniqueItemId}-${option.key}`"
                        v-model="model"
                        :value="option.key"
                        :disabled="option.disabled"
                        @click="handleClick"
                        @blur="handleBlur"
                        @change="handleInput"
                    />
                    <span v-html="option.displayLabel"></span>
                </label>
            </div>
        </div>
        <FieldErrorMessage :path="path" :backend="backend" />
    </div>
</template>

<style scoped>
.is-readonly .multiselect-checkbox-field-item {
    opacity: 0.5;
    pointer-events: none;
}

.is-readonly input[type="checkbox"] {
    cursor: not-allowed;
}
</style>
